// extracted by mini-css-extract-plugin
export default {"typeIndicator":"styles_typeIndicator__ZeSR0","dotFlashing":"styles_dotFlashing__Z7IrR","dot-flashing":"styles_dot-flashing__aDRtS"};